import { render, staticRenderFns } from "./es.vue?vue&type=template&id=6ca7b898"
import script from "./es.vue?vue&type=script&lang=js"
export * from "./es.vue?vue&type=script&lang=js"
import style0 from "./es.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-mailing/es.vue
// module id = U9lB
// module chunks = 0